// export const subscriptionType = {
//     regular: 'Producent',
//     dealer: 'Forhandler',
//     maskinstationerRegular: 'Maskinstationer regular',
//     maskinstationerMini: 'Maskinstationer mini'
// };

export const REGULAR_TYPE = '0';
export const REGULAR_MINI_TYPE = '4';
export const DEALER_TYPE = '1';
export const MASKINSTATIONER_REGULAR = '2';
export const MASKINSTATIONER_MINI = '3';

export const subscriptionType = [
    {
        title: 'Standard',
        value: REGULAR_TYPE,
    },
    {
        title: 'Forhandler',
        value: DEALER_TYPE,
    },
    {
        title: 'Maskinstationer regular',
        value: MASKINSTATIONER_REGULAR,
    },
    {
        title: 'Maskinstationer mini',
        value: MASKINSTATIONER_MINI,
    },
    {
        title: 'Standard mini',
        value: REGULAR_MINI_TYPE,
    }
];


// WEBPACK FOOTER //
// ./web/src/components/company/subscriptionType.js